// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */ // MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
// [trivia] This class is called Broccoli because broccoli has a stalk, and this
// sort of "stalks" the user's behavior... :)
//
// TODO (Zanchi): Remove jQuery
// modern-bundle! import $ from 'sitewide-jquery';
// modern-bundle! import _ from 'lodash';
// modern-bundle! import 'js/core_pre_webpack/utils/general_helpers';
// modern-bundle! import { Kale } from 'js/core_webpack/metrics/kale';
class Broccoli {
  static initClass() {
    this.prototype.DEFAULT_FEATURES = {
      listenForClicks: true,
      listenForHashChange: false
    };
  }
  // TODO: get rid of this once we make this an IIFE and only have one instance
  // on a page. I think the main blocker right now is the reg path, as we have
  // multiple instances of broccoli being created there.
  disable() {
    $(document).off('click.broccoli', '[data-broccoli-component]');
    return window.$a.log('[Broccoli Features] listenForClicks disabled:', this);
  }
  enable(newEnabledFeatures) {
    if (newEnabledFeatures == null) {
      newEnabledFeatures = {};
    }
    if (!this._enabledFeatures) {
      this._enabledFeatures = {};
    }
    if (newEnabledFeatures.listenForHashChange && !this._enabledFeatures.listenForHashChange) {
      this.notifyPageViewed(); // log first time visiting page
      this._listenForHashChange();
    }
    if (newEnabledFeatures.listenForClicks && !this._enabledFeatures.listenForClicks) {
      this._listenForClicks();
    }
    // update currently enabled features
    return _.extend(this._enabledFeatures, newEnabledFeatures);
  }
  notifyPageViewed(eventData, collectionName) {
    if (eventData == null) {
      eventData = {};
    }
    if (collectionName == null) {
      collectionName = this.defaultCollection;
    }
    return this.notify('page-viewed', _.extend(eventData, {
      url: window.location.toString()
    }), collectionName);
  }
  notifyComponentClicked(domElement, eventData, collectionName) {
    let componentData;
    if (eventData == null) {
      eventData = {};
    }
    if (collectionName == null) {
      collectionName = this.defaultCollection;
    }
    const $domElement = $(domElement);
    if ($domElement.length === 0) {
      window.$a.error('[Broccoli Error]: invalid domElement in notifyComponentClicked');
      return;
    }
    const component = $domElement.attr('data-broccoli-component');
    if (!component) {
      window.$a.error('[Broccoli Error]: invalid component in notifyComponentClicked');
      return;
    }
    collectionName = $domElement.attr('data-broccoli-collection') || collectionName;
    try {
      componentData = JSON.parse($domElement.attr('data-broccoli-data') || '{}');
      // Add viewed user id to the profile collection
      if (collectionName === 'profile') {
        return componentData = _.extend({
          viewed_user_id: Aedu.User.viewed != null ? Aedu.User.viewed.id : undefined
        }, componentData);
      }
    } catch (error) {
      componentData = {};
      return window.$a.error(`[Broccoli Error] Unable to parse data for ${component}`);
    } finally {
      Kale.notifyEvent({
        collectionName,
        componentName: component,
        componentAction: 'clicked',
        eventData: _.extend(eventData, componentData)
      });
    }
  }
  notify(event, eventData, collectionName) {
    if (eventData == null) {
      eventData = {};
    }
    if (collectionName == null) {
      collectionName = this.defaultCollection;
    }
    return Kale.notify({
      collectionName,
      eventData: _.extend(eventData, {
        event
      })
    });
  }
  _listenForClicks() {
    $(document).on('click.broccoli', '[data-broccoli-component]', e => {
      return this.notifyComponentClicked(e.currentTarget);
    });
    return window.$a.log('[Broccoli Features] listenForClicks enabled:', this);
  }
  // the intent for this is to log an event in a single page app when the user
  // has changed the page by listening on the 'hashchange' event. Idea from:
  // http://stackoverflow.com/a/2162174
  _listenForHashChange() {
    $(window).on('hashchange.broccoli', () => {
      return this.notifyPageViewed();
    });
    return window.$a.log('[Broccoli Features] listenForHashChange enabled:', this);
  }
  constructor(options) {
    if (options == null) {
      options = {};
    }
    this.defaultCollection = options.defaultCollection;
    if (!this.defaultCollection) {
      window.$a.error('[Broccoli Error]: must set defaultCollection on instantiation');
      return;
    }
    const defaultFeatures = _.clone(options.defaultFeatures) || {};
    _.defaults(defaultFeatures, this.DEFAULT_FEATURES);
    window.$a.log('[Broccoli Instantiated]:', this);
    this.enable(defaultFeatures);
  }
}
Broccoli.initClass();
if (window.Aedu) {
  Aedu.Broccoli = Broccoli;
} // modern-bundle! export default Broccoli
window.Broccoli = Broccoli;